
let is_bundle = document.querySelector('.product-form__bundle');

function viewedProduct(productJson, productPrice, productReducedPrice) {
  // Get the existing array from localStorage or create a new one if it doesn't exist
  let viewedProducts = JSON.parse(localStorage.getItem('viewedProducts')) || [];

  // Extract only the required information from the product JSON
  const simplifiedProduct = {
    id: productJson.id, // We'll use this for checking duplicates
    handle: productJson.handle,
    title: productJson.title,
    featured_image: productJson.featured_image,
    price: productPrice,
    originalPrice: productReducedPrice,
    vendor: productJson.vendor,
    variant_id: productJson.variants[0].id,
    variant_title: productJson.variants[0].title,
    product_sticker: productJson.product_sticker
  };

  // Check if the product already exists in the array
  const productExists = viewedProducts.some(product => product.id === simplifiedProduct.id);

  // If the product does not exist, add it to the array
  if (!productExists) {
    viewedProducts.push(simplifiedProduct);

    // Limit the array to store only the last 10 viewed products
    if (viewedProducts.length > 10) {
      viewedProducts = viewedProducts.slice(-10);
    }

    // Store the updated array back in localStorage
    localStorage.setItem('viewedProducts', JSON.stringify(viewedProducts));
  }
}

document.addEventListener("DOMContentLoaded", () => {
  let quantityButtons = document.querySelectorAll('.quantity-button');
  quantityButtons.forEach((quantityButton) => {
    quantityButton.addEventListener('click', () => {
      let type = quantityButton.dataset.action;
      if (type == "minus") {
        let input = quantityButton.nextElementSibling;
        let inputValue = input.value;
        inputValue = --inputValue;
        if (inputValue < 1) {
          input.value = 1;
        } else {
          input.value = inputValue;
        }
      } else {
        let input = quantityButton.previousElementSibling;
        let inputValue = input.value;
        inputValue = ++inputValue;
        input.value = inputValue;
      }
    })
  });

  let submits = document.querySelectorAll('.add-to-cart');
  submits.forEach((submit) => {
    submit.addEventListener('click', (e) => {
      e.preventDefault();

      let productFormToggle = submit.dataset.productForm;
      let is_bundle = document.querySelector('.product-form__bundle');

      let is_different = false;

      if (productFormToggle == "is-form") {
        let extras_form = document.querySelector('.product-form__extra-form');
        if (extras_form) {

          let alertPopup = document.querySelector('#product-warning__container');
          let strength_buttons = extras_form.querySelectorAll('.strength-button');
          let flavour_selectors = extras_form.querySelectorAll('select');

          let hasSelected = false;
          let hasChosen = false;
          let showPopup = true;
          
          let showWarning = false;

          let strength = '0mg';
          let freeProducts = [];

          strength_buttons.forEach((button) => {
            if (button.classList.contains('selected')) {
              hasSelected = true;
              strength = button.innerText;
            }
          });

          let allSelected = false;
          let anySelected = false;

          let selectedIndexArray = [];
          
          flavour_selectors.forEach((selector) => {
            var selectedIndex = selector.selectedIndex;
            selectedIndexArray.push(selectedIndex);
            console.log(selectedIndexArray);
            if(flavour_selectors.length == selectedIndexArray.length){
              if(!selectedIndexArray.includes(0)){
                
                allSelected = true;
                hasChosen = true;
                showPopup = false;

                selectedIndexArray.forEach((item) => {
                  let options = selector.options;
                  let option = options[item].getAttribute(`data-${strength}`);
                  freeProducts.push(option);
                })

              } else {
                showPopup = true;
                hasChosen = false;
                freeProducts = [];
              }
            }
          });

          console.log('Has selected? ', hasSelected);
          console.log('Has chosen? ', hasChosen);

          console.log('All selected? ', allSelected);
          console.log('Any chosen? ', anySelected);
          


          if (showPopup) {
            
            alertPopup.classList.remove('hidden');
            let goBack = document.querySelector('.product-warning__button-back');
            let goContinue = document.querySelector('.product-warning__button-continue');
            goBack.addEventListener('click', () => {
              alertPopup.classList.add('hidden');
              if (window.matchMedia("(max-width: 989px)").matches) {
                document.querySelector('.product-form__key-features').scrollIntoView({ behavior: "smooth" });
              }
            });
            goContinue.addEventListener('click', () => {
              addToCart(false);
            });
          } else if(!showPopup && hasChosen && hasSelected) {
            // console.log(freeProducts);
            addToCart(true, freeProducts);
          }
        } else {
          // this check was added to chosen a strength but not a flavour
          let interm_flavour_selector = document.querySelectorAll('.interim-flavour-selector__element');
          if (interm_flavour_selector.length > 0) {
            // Duty panels can show one select per panel: decide once across the visible ones.
            const visibleSelectors = Array.from(interm_flavour_selector).filter(selector => !selector.classList.contains('hidden'));
            const hasFlavour = visibleSelectors.some(selector => selector.value !== '');
            document.querySelector(".bundle-form__warning").classList.toggle("hidden", hasFlavour);
            if (hasFlavour) {
              addToCart(null);
            }
          } else { 
            
            addToCart(null);
          }
        }
      } else {
        let id = submit.dataset.id;
        addToCart(null, null, id);
      }
    });
  });
});

function addToCart(hasChosen, freeProducts, id) {
  let variantId;
  let quantity;
  if (id) {
    variantId = id;
    quantity = 1;
  } else {
    variantId = document.querySelector('[name="id"]').value;
    quantity = document.querySelector('#quantity').value;
  }

  let formData = {};
  if (!hasChosen && !id) {
    if (is_bundle) {
      let bundle_selects = document.querySelectorAll('.product-bundle__dropdown');
      let noOfChildProducts = document.querySelector('.product-form__bundle').dataset.columnCount;
      let bundle_variant_ids = '';



      const bundle_selects_array = Array.from(bundle_selects);

      bundle_selects_array.forEach((select, index) => {
        if (select.value !== "no-item") {
          bundle_variant_ids += `gid://shopify/ProductVariant/${select.value}`;

          // Find if there is any subsequent valid item to add a comma after this
          if (bundle_selects_array.slice(index + 1).some(s => s.value !== "no-item")) {
            bundle_variant_ids += ',';
          }
        }
      });
      if (bundle_variant_ids.split(",").length != noOfChildProducts) {
        document.querySelector('.bundle-form__warning').classList.remove('hidden');
        return;
      } else {
        document.querySelector('.bundle-form__warning').classList.add('hidden');
      }
      let bundle_selected = {
        '_isBundle': 'true',
        '_bundleIds': bundle_variant_ids
      };

      formData = {
        'items': [
          {
            'id': variantId, // Main product
            'quantity': quantity,
            'properties': bundle_selected

          }
        ]
      };
    } else {
      formData = {
        'items': [{
          'id': variantId,
          'quantity': quantity
           
        }]
      };
    }
  } else if (hasChosen) {
    let parentProductHandle = document.querySelector('.product-form__freebies').dataset.productHandle;
    let products = freeProducts;
    formData = {
      'items': [
        {
          'id': variantId,
          'quantity': quantity,
        },
        ...products.map(productId => ({
          'id': productId,
          'quantity': 1,
          properties: {
            '_offerFreeProduct': `free-for-${parentProductHandle}`
          }
        }))
      ]
    };
  } else {
    if (window.is_combo) {

      formData = {
        'items': [{
          'id': variantId,
          'quantity': quantity,
          'properties': {
            '_combo': window.comboPercentage
          }
        }]
      };

    } else {
      formData = {
        'items': [{
          'id': variantId,
          'quantity': quantity
        }]
      };
    }

  }
  // Paid nic shots (snippets/nic-shot-addon.liquid): the customer must choose
  // before Add to Bag. "none" adds the shortfill alone, a variant id adds
  // count x bottles of that variant at full price alongside the shortfill.
  var nicShotSelect = document.querySelector('.nic-shot-addon__variant');
  if (nicShotSelect && !id && formData.items) {
    var nicShotError = document.querySelector('.nic-shot-addon__error');
    if (nicShotSelect.value === '') {
      if (nicShotError) nicShotError.classList.remove('hidden');
      nicShotSelect.scrollIntoView({ block: 'center', behavior: 'smooth' });
      nicShotSelect.focus();
      return;
    }
    if (nicShotError) nicShotError.classList.add('hidden');
    if (nicShotSelect.value !== 'none') {
      var nicShotCount = parseInt(nicShotSelect.closest('.nic-shot-addon').dataset.nicShotCount, 10) || 1;
      var nicShotBottles = Math.max(1, parseInt(quantity, 10) || 1);
      formData.items.push({
        'id': nicShotSelect.value,
        'quantity': nicShotCount * nicShotBottles,
        'properties': {
          '_nicShotFor': document.querySelector('.main-product-form__atc').dataset.productHandle
        }
      });
    }
  }
  if (document.querySelector('.main-product-form__atc')) {

    let hidden_free_product_ids = document.querySelector('.main-product-form__atc').dataset.hiddenFreeProductIds;
    let hidden_free_product_quantity = document.querySelector('.main-product-form__atc').dataset.hiddenFreeProductQuantity;
    let quantityElement = document.querySelector('input[name="quantity"]');
    let quantity = quantityElement ? parseInt(quantityElement.value) : 1;

    if (hidden_free_product_ids) {
      hidden_free_product_ids.split(',').forEach(productId => {
        formData.items.push({
          'id': productId,
          'quantity': hidden_free_product_quantity ? parseInt(hidden_free_product_quantity) * quantity : quantity,
          'properties': {
            '_hiddenFree': 'free-for-' + document.querySelector('.main-product-form__atc').dataset.productHandle,
            '_hiddenFreeQuantity': hidden_free_product_quantity ? parseInt(hidden_free_product_quantity) : quantity
        }
          
        });
      });
    }
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {

      return response.json();
    })
    .then(data => {
      

      document.querySelector('#product-warning__container').classList.add('hidden');
      toggleCartDrawer();
      console.log('Success:', data);
      ometria.trackAddToBasket(data.items[0].product_id, quantity);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

document.addEventListener('change', function (e) {
  if (!e.target.classList || !e.target.classList.contains('nic-shot-addon__variant')) return;
  var nicShotError = document.querySelector('.nic-shot-addon__error');
  if (nicShotError && e.target.value !== '') nicShotError.classList.add('hidden');
});
